import { renderCompanyFounders } from "./CompanyFounders";
import { renderCompanyMarketCap } from "./CompanyMarketCap";
import { renderRichestPeopleCard } from "./RichestPeopleCard";
import type { WealthResponse } from "./WealthTypes";

const API = "https://api.ayesearch.com/api/billionaires/intelligence/";

export function looksLikeWealthIntelligenceQuery(query: string): boolean {
  const q = String(query || "").toLowerCase();
  return (
    /\b(?:richest|wealthiest|billionaires?)\b/.test(q) ||
    /\bfounders?\s+of\b/.test(q) ||
    /\bwho\s+(?:is|was|are)\s+(?:the\s+)?founders?\s+of\b/.test(q) ||
    /\bmarket\s*cap(?:italization)?\b/.test(q) ||
    /\bmarket value\b/.test(q)
  );
}

export async function resolveWealthIntelligence(query: string): Promise<WealthResponse | null> {
  const url = new URL(API);
  url.searchParams.set("q", query);
  const response = await fetch(url.toString(), {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) return null;
  const data = (await response.json()) as WealthResponse;
  if (response.status === 404) return null;
  if (!response.ok || data.error) throw new Error(data.error || `Wealth intelligence API returned HTTP ${response.status}`);
  return data;
}

export function renderWealthIntelligence(container: HTMLElement, data: WealthResponse): boolean {
  if (data.kind === "richest" || data.kind === "historical") {
    renderRichestPeopleCard(container, data);
    return true;
  }
  if (data.kind === "founder") {
    renderCompanyFounders(container, data);
    return true;
  }
  if (data.kind === "market_cap") {
    renderCompanyMarketCap(container, data);
    return true;
  }
  return false;
}

export async function renderWealthIntelligenceCard(container: HTMLElement, query: string): Promise<boolean> {
  try {
    const data = await resolveWealthIntelligence(query);
    if (!data) return false;
    return renderWealthIntelligence(container, data);
  } catch (error) {
    console.error("AyeSearch wealth intelligence failed:", error);
    return false;
  }
}
